/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as nonAuthLoginImport } from './routes/(non-auth)/login'
import { Route as authLayoutImport } from './routes/(auth)/_layout'
import { Route as nonAuthDeeplinkIndexImport } from './routes/(non-auth)/deeplink/index'
import { Route as authLayoutIndexImport } from './routes/(auth)/_layout/index'
import { Route as nonAuthDeeplinkSalesManagementChangeImport } from './routes/(non-auth)/deeplink/sales-management-change'
import { Route as authLayoutTaxAccountantIndexImport } from './routes/(auth)/_layout/tax-accountant/index'
import { Route as authLayoutSearchIndexImport } from './routes/(auth)/_layout/search/index'
import { Route as authLayoutPrizeIndexImport } from './routes/(auth)/_layout/prize/index'
import { Route as authLayoutManageIndexImport } from './routes/(auth)/_layout/manage/index'
import { Route as authLayoutBusinessIndexImport } from './routes/(auth)/_layout/business/index'
import { Route as authLayoutApprovalIndexImport } from './routes/(auth)/_layout/approval/index'
import { Route as authLayoutTaxCorporationTaxCorporationIdImport } from './routes/(auth)/_layout/tax-corporation/$taxCorporationId'
import { Route as authLayoutTaxAccountantRegistrationStatusImport } from './routes/(auth)/_layout/tax-accountant/registration-status'
import { Route as authLayoutTaxAccountantRegisterImport } from './routes/(auth)/_layout/tax-accountant/register'
import { Route as authLayoutSearchSimpleSearchImport } from './routes/(auth)/_layout/search/simple-search'
import { Route as authLayoutSearchMapSearchImport } from './routes/(auth)/_layout/search/map-search'
import { Route as authLayoutSearchDetailSearchImport } from './routes/(auth)/_layout/search/detail-search'
import { Route as authLayoutManageReportManage2Import } from './routes/(auth)/_layout/manage/report-manage-2'
import { Route as authLayoutManageReportManage1Import } from './routes/(auth)/_layout/manage/report-manage-1'
import { Route as authLayoutApprovalRequestIdImport } from './routes/(auth)/_layout/approval/$requestId'
import { Route as authLayoutTaxAccountantTaxAccountantIdIndexImport } from './routes/(auth)/_layout/tax-accountant/$taxAccountantId/index'
import { Route as authLayoutManageTaxAccountantConsultationIndexImport } from './routes/(auth)/_layout/manage/tax-accountant-consultation/index'
import { Route as authLayoutManageCustomerManageIndexImport } from './routes/(auth)/_layout/manage/customer-manage/index'
import { Route as authLayoutTaxAccountantTaxAccountantIdModifyImport } from './routes/(auth)/_layout/tax-accountant/$taxAccountantId/modify'
import { Route as authLayoutManageTaxAccountantConsultationRegisterImport } from './routes/(auth)/_layout/manage/tax-accountant-consultation/register'
import { Route as authLayoutManageCustomerManageRegisterImport } from './routes/(auth)/_layout/manage/customer-manage/register'
import { Route as authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexImport } from './routes/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/index'
import { Route as authLayoutManageCustomerManageCustomerManageIdIndexImport } from './routes/(auth)/_layout/manage/customer-manage/$customerManageId/index'
import { Route as authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyImport } from './routes/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
import { Route as authLayoutManageCustomerManageCustomerManageIdModifyImport } from './routes/(auth)/_layout/manage/customer-manage/$customerManageId/modify'

// Create Virtual Routes

const authImport = createFileRoute('/(auth)')()

// Create/Update Routes

const authRoute = authImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRoute,
} as any)

const nonAuthLoginRoute = nonAuthLoginImport.update({
  id: '/(non-auth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const authLayoutRoute = authLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => authRoute,
} as any)

const nonAuthDeeplinkIndexRoute = nonAuthDeeplinkIndexImport.update({
  id: '/(non-auth)/deeplink/',
  path: '/deeplink/',
  getParentRoute: () => rootRoute,
} as any)

const authLayoutIndexRoute = authLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authLayoutRoute,
} as any)

const nonAuthDeeplinkSalesManagementChangeRoute =
  nonAuthDeeplinkSalesManagementChangeImport.update({
    id: '/(non-auth)/deeplink/sales-management-change',
    path: '/deeplink/sales-management-change',
    getParentRoute: () => rootRoute,
  } as any)

const authLayoutTaxAccountantIndexRoute =
  authLayoutTaxAccountantIndexImport.update({
    id: '/tax-accountant/',
    path: '/tax-accountant/',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutSearchIndexRoute = authLayoutSearchIndexImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLayoutPrizeIndexRoute = authLayoutPrizeIndexImport.update({
  id: '/prize/',
  path: '/prize/',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLayoutManageIndexRoute = authLayoutManageIndexImport.update({
  id: '/manage/',
  path: '/manage/',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLayoutBusinessIndexRoute = authLayoutBusinessIndexImport.update({
  id: '/business/',
  path: '/business/',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLayoutApprovalIndexRoute = authLayoutApprovalIndexImport.update({
  id: '/approval/',
  path: '/approval/',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLayoutTaxCorporationTaxCorporationIdRoute =
  authLayoutTaxCorporationTaxCorporationIdImport.update({
    id: '/tax-corporation/$taxCorporationId',
    path: '/tax-corporation/$taxCorporationId',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutTaxAccountantRegistrationStatusRoute =
  authLayoutTaxAccountantRegistrationStatusImport.update({
    id: '/tax-accountant/registration-status',
    path: '/tax-accountant/registration-status',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutTaxAccountantRegisterRoute =
  authLayoutTaxAccountantRegisterImport.update({
    id: '/tax-accountant/register',
    path: '/tax-accountant/register',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutSearchSimpleSearchRoute =
  authLayoutSearchSimpleSearchImport.update({
    id: '/search/simple-search',
    path: '/search/simple-search',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutSearchMapSearchRoute = authLayoutSearchMapSearchImport.update({
  id: '/search/map-search',
  path: '/search/map-search',
  getParentRoute: () => authLayoutRoute,
} as any)

const authLayoutSearchDetailSearchRoute =
  authLayoutSearchDetailSearchImport.update({
    id: '/search/detail-search',
    path: '/search/detail-search',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageReportManage2Route =
  authLayoutManageReportManage2Import.update({
    id: '/manage/report-manage-2',
    path: '/manage/report-manage-2',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageReportManage1Route =
  authLayoutManageReportManage1Import.update({
    id: '/manage/report-manage-1',
    path: '/manage/report-manage-1',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutApprovalRequestIdRoute =
  authLayoutApprovalRequestIdImport.update({
    id: '/approval/$requestId',
    path: '/approval/$requestId',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutTaxAccountantTaxAccountantIdIndexRoute =
  authLayoutTaxAccountantTaxAccountantIdIndexImport.update({
    id: '/tax-accountant/$taxAccountantId/',
    path: '/tax-accountant/$taxAccountantId/',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageTaxAccountantConsultationIndexRoute =
  authLayoutManageTaxAccountantConsultationIndexImport.update({
    id: '/manage/tax-accountant-consultation/',
    path: '/manage/tax-accountant-consultation/',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageCustomerManageIndexRoute =
  authLayoutManageCustomerManageIndexImport.update({
    id: '/manage/customer-manage/',
    path: '/manage/customer-manage/',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutTaxAccountantTaxAccountantIdModifyRoute =
  authLayoutTaxAccountantTaxAccountantIdModifyImport.update({
    id: '/tax-accountant/$taxAccountantId/modify',
    path: '/tax-accountant/$taxAccountantId/modify',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageTaxAccountantConsultationRegisterRoute =
  authLayoutManageTaxAccountantConsultationRegisterImport.update({
    id: '/manage/tax-accountant-consultation/register',
    path: '/manage/tax-accountant-consultation/register',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageCustomerManageRegisterRoute =
  authLayoutManageCustomerManageRegisterImport.update({
    id: '/manage/customer-manage/register',
    path: '/manage/customer-manage/register',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute =
  authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexImport.update(
    {
      id: '/manage/tax-accountant-consultation/$taxAccountantConsultationId/',
      path: '/manage/tax-accountant-consultation/$taxAccountantConsultationId/',
      getParentRoute: () => authLayoutRoute,
    } as any,
  )

const authLayoutManageCustomerManageCustomerManageIdIndexRoute =
  authLayoutManageCustomerManageCustomerManageIdIndexImport.update({
    id: '/manage/customer-manage/$customerManageId/',
    path: '/manage/customer-manage/$customerManageId/',
    getParentRoute: () => authLayoutRoute,
  } as any)

const authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute =
  authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyImport.update(
    {
      id: '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify',
      path: '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify',
      getParentRoute: () => authLayoutRoute,
    } as any,
  )

const authLayoutManageCustomerManageCustomerManageIdModifyRoute =
  authLayoutManageCustomerManageCustomerManageIdModifyImport.update({
    id: '/manage/customer-manage/$customerManageId/modify',
    path: '/manage/customer-manage/$customerManageId/modify',
    getParentRoute: () => authLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/_layout': {
      id: '/(auth)/_layout'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authLayoutImport
      parentRoute: typeof authRoute
    }
    '/(non-auth)/login': {
      id: '/(non-auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof nonAuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/(non-auth)/deeplink/sales-management-change': {
      id: '/(non-auth)/deeplink/sales-management-change'
      path: '/deeplink/sales-management-change'
      fullPath: '/deeplink/sales-management-change'
      preLoaderRoute: typeof nonAuthDeeplinkSalesManagementChangeImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/_layout/': {
      id: '/(auth)/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authLayoutIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(non-auth)/deeplink/': {
      id: '/(non-auth)/deeplink/'
      path: '/deeplink'
      fullPath: '/deeplink'
      preLoaderRoute: typeof nonAuthDeeplinkIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/_layout/approval/$requestId': {
      id: '/(auth)/_layout/approval/$requestId'
      path: '/approval/$requestId'
      fullPath: '/approval/$requestId'
      preLoaderRoute: typeof authLayoutApprovalRequestIdImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/report-manage-1': {
      id: '/(auth)/_layout/manage/report-manage-1'
      path: '/manage/report-manage-1'
      fullPath: '/manage/report-manage-1'
      preLoaderRoute: typeof authLayoutManageReportManage1Import
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/report-manage-2': {
      id: '/(auth)/_layout/manage/report-manage-2'
      path: '/manage/report-manage-2'
      fullPath: '/manage/report-manage-2'
      preLoaderRoute: typeof authLayoutManageReportManage2Import
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/search/detail-search': {
      id: '/(auth)/_layout/search/detail-search'
      path: '/search/detail-search'
      fullPath: '/search/detail-search'
      preLoaderRoute: typeof authLayoutSearchDetailSearchImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/search/map-search': {
      id: '/(auth)/_layout/search/map-search'
      path: '/search/map-search'
      fullPath: '/search/map-search'
      preLoaderRoute: typeof authLayoutSearchMapSearchImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/search/simple-search': {
      id: '/(auth)/_layout/search/simple-search'
      path: '/search/simple-search'
      fullPath: '/search/simple-search'
      preLoaderRoute: typeof authLayoutSearchSimpleSearchImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/tax-accountant/register': {
      id: '/(auth)/_layout/tax-accountant/register'
      path: '/tax-accountant/register'
      fullPath: '/tax-accountant/register'
      preLoaderRoute: typeof authLayoutTaxAccountantRegisterImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/tax-accountant/registration-status': {
      id: '/(auth)/_layout/tax-accountant/registration-status'
      path: '/tax-accountant/registration-status'
      fullPath: '/tax-accountant/registration-status'
      preLoaderRoute: typeof authLayoutTaxAccountantRegistrationStatusImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/tax-corporation/$taxCorporationId': {
      id: '/(auth)/_layout/tax-corporation/$taxCorporationId'
      path: '/tax-corporation/$taxCorporationId'
      fullPath: '/tax-corporation/$taxCorporationId'
      preLoaderRoute: typeof authLayoutTaxCorporationTaxCorporationIdImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/approval/': {
      id: '/(auth)/_layout/approval/'
      path: '/approval'
      fullPath: '/approval'
      preLoaderRoute: typeof authLayoutApprovalIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/business/': {
      id: '/(auth)/_layout/business/'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof authLayoutBusinessIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/': {
      id: '/(auth)/_layout/manage/'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof authLayoutManageIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/prize/': {
      id: '/(auth)/_layout/prize/'
      path: '/prize'
      fullPath: '/prize'
      preLoaderRoute: typeof authLayoutPrizeIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/search/': {
      id: '/(auth)/_layout/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof authLayoutSearchIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/tax-accountant/': {
      id: '/(auth)/_layout/tax-accountant/'
      path: '/tax-accountant'
      fullPath: '/tax-accountant'
      preLoaderRoute: typeof authLayoutTaxAccountantIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/customer-manage/register': {
      id: '/(auth)/_layout/manage/customer-manage/register'
      path: '/manage/customer-manage/register'
      fullPath: '/manage/customer-manage/register'
      preLoaderRoute: typeof authLayoutManageCustomerManageRegisterImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/tax-accountant-consultation/register': {
      id: '/(auth)/_layout/manage/tax-accountant-consultation/register'
      path: '/manage/tax-accountant-consultation/register'
      fullPath: '/manage/tax-accountant-consultation/register'
      preLoaderRoute: typeof authLayoutManageTaxAccountantConsultationRegisterImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/tax-accountant/$taxAccountantId/modify': {
      id: '/(auth)/_layout/tax-accountant/$taxAccountantId/modify'
      path: '/tax-accountant/$taxAccountantId/modify'
      fullPath: '/tax-accountant/$taxAccountantId/modify'
      preLoaderRoute: typeof authLayoutTaxAccountantTaxAccountantIdModifyImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/customer-manage/': {
      id: '/(auth)/_layout/manage/customer-manage/'
      path: '/manage/customer-manage'
      fullPath: '/manage/customer-manage'
      preLoaderRoute: typeof authLayoutManageCustomerManageIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/tax-accountant-consultation/': {
      id: '/(auth)/_layout/manage/tax-accountant-consultation/'
      path: '/manage/tax-accountant-consultation'
      fullPath: '/manage/tax-accountant-consultation'
      preLoaderRoute: typeof authLayoutManageTaxAccountantConsultationIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/tax-accountant/$taxAccountantId/': {
      id: '/(auth)/_layout/tax-accountant/$taxAccountantId/'
      path: '/tax-accountant/$taxAccountantId'
      fullPath: '/tax-accountant/$taxAccountantId'
      preLoaderRoute: typeof authLayoutTaxAccountantTaxAccountantIdIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/customer-manage/$customerManageId/modify': {
      id: '/(auth)/_layout/manage/customer-manage/$customerManageId/modify'
      path: '/manage/customer-manage/$customerManageId/modify'
      fullPath: '/manage/customer-manage/$customerManageId/modify'
      preLoaderRoute: typeof authLayoutManageCustomerManageCustomerManageIdModifyImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify': {
      id: '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
      path: '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
      fullPath: '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
      preLoaderRoute: typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/customer-manage/$customerManageId/': {
      id: '/(auth)/_layout/manage/customer-manage/$customerManageId/'
      path: '/manage/customer-manage/$customerManageId'
      fullPath: '/manage/customer-manage/$customerManageId'
      preLoaderRoute: typeof authLayoutManageCustomerManageCustomerManageIdIndexImport
      parentRoute: typeof authLayoutImport
    }
    '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/': {
      id: '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/'
      path: '/manage/tax-accountant-consultation/$taxAccountantConsultationId'
      fullPath: '/manage/tax-accountant-consultation/$taxAccountantConsultationId'
      preLoaderRoute: typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexImport
      parentRoute: typeof authLayoutImport
    }
  }
}

// Create and export the route tree

interface authLayoutRouteChildren {
  authLayoutIndexRoute: typeof authLayoutIndexRoute
  authLayoutApprovalRequestIdRoute: typeof authLayoutApprovalRequestIdRoute
  authLayoutManageReportManage1Route: typeof authLayoutManageReportManage1Route
  authLayoutManageReportManage2Route: typeof authLayoutManageReportManage2Route
  authLayoutSearchDetailSearchRoute: typeof authLayoutSearchDetailSearchRoute
  authLayoutSearchMapSearchRoute: typeof authLayoutSearchMapSearchRoute
  authLayoutSearchSimpleSearchRoute: typeof authLayoutSearchSimpleSearchRoute
  authLayoutTaxAccountantRegisterRoute: typeof authLayoutTaxAccountantRegisterRoute
  authLayoutTaxAccountantRegistrationStatusRoute: typeof authLayoutTaxAccountantRegistrationStatusRoute
  authLayoutTaxCorporationTaxCorporationIdRoute: typeof authLayoutTaxCorporationTaxCorporationIdRoute
  authLayoutApprovalIndexRoute: typeof authLayoutApprovalIndexRoute
  authLayoutBusinessIndexRoute: typeof authLayoutBusinessIndexRoute
  authLayoutManageIndexRoute: typeof authLayoutManageIndexRoute
  authLayoutPrizeIndexRoute: typeof authLayoutPrizeIndexRoute
  authLayoutSearchIndexRoute: typeof authLayoutSearchIndexRoute
  authLayoutTaxAccountantIndexRoute: typeof authLayoutTaxAccountantIndexRoute
  authLayoutManageCustomerManageRegisterRoute: typeof authLayoutManageCustomerManageRegisterRoute
  authLayoutManageTaxAccountantConsultationRegisterRoute: typeof authLayoutManageTaxAccountantConsultationRegisterRoute
  authLayoutTaxAccountantTaxAccountantIdModifyRoute: typeof authLayoutTaxAccountantTaxAccountantIdModifyRoute
  authLayoutManageCustomerManageIndexRoute: typeof authLayoutManageCustomerManageIndexRoute
  authLayoutManageTaxAccountantConsultationIndexRoute: typeof authLayoutManageTaxAccountantConsultationIndexRoute
  authLayoutTaxAccountantTaxAccountantIdIndexRoute: typeof authLayoutTaxAccountantTaxAccountantIdIndexRoute
  authLayoutManageCustomerManageCustomerManageIdModifyRoute: typeof authLayoutManageCustomerManageCustomerManageIdModifyRoute
  authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute: typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute
  authLayoutManageCustomerManageCustomerManageIdIndexRoute: typeof authLayoutManageCustomerManageCustomerManageIdIndexRoute
  authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute: typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute
}

const authLayoutRouteChildren: authLayoutRouteChildren = {
  authLayoutIndexRoute: authLayoutIndexRoute,
  authLayoutApprovalRequestIdRoute: authLayoutApprovalRequestIdRoute,
  authLayoutManageReportManage1Route: authLayoutManageReportManage1Route,
  authLayoutManageReportManage2Route: authLayoutManageReportManage2Route,
  authLayoutSearchDetailSearchRoute: authLayoutSearchDetailSearchRoute,
  authLayoutSearchMapSearchRoute: authLayoutSearchMapSearchRoute,
  authLayoutSearchSimpleSearchRoute: authLayoutSearchSimpleSearchRoute,
  authLayoutTaxAccountantRegisterRoute: authLayoutTaxAccountantRegisterRoute,
  authLayoutTaxAccountantRegistrationStatusRoute:
    authLayoutTaxAccountantRegistrationStatusRoute,
  authLayoutTaxCorporationTaxCorporationIdRoute:
    authLayoutTaxCorporationTaxCorporationIdRoute,
  authLayoutApprovalIndexRoute: authLayoutApprovalIndexRoute,
  authLayoutBusinessIndexRoute: authLayoutBusinessIndexRoute,
  authLayoutManageIndexRoute: authLayoutManageIndexRoute,
  authLayoutPrizeIndexRoute: authLayoutPrizeIndexRoute,
  authLayoutSearchIndexRoute: authLayoutSearchIndexRoute,
  authLayoutTaxAccountantIndexRoute: authLayoutTaxAccountantIndexRoute,
  authLayoutManageCustomerManageRegisterRoute:
    authLayoutManageCustomerManageRegisterRoute,
  authLayoutManageTaxAccountantConsultationRegisterRoute:
    authLayoutManageTaxAccountantConsultationRegisterRoute,
  authLayoutTaxAccountantTaxAccountantIdModifyRoute:
    authLayoutTaxAccountantTaxAccountantIdModifyRoute,
  authLayoutManageCustomerManageIndexRoute:
    authLayoutManageCustomerManageIndexRoute,
  authLayoutManageTaxAccountantConsultationIndexRoute:
    authLayoutManageTaxAccountantConsultationIndexRoute,
  authLayoutTaxAccountantTaxAccountantIdIndexRoute:
    authLayoutTaxAccountantTaxAccountantIdIndexRoute,
  authLayoutManageCustomerManageCustomerManageIdModifyRoute:
    authLayoutManageCustomerManageCustomerManageIdModifyRoute,
  authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute:
    authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute,
  authLayoutManageCustomerManageCustomerManageIdIndexRoute:
    authLayoutManageCustomerManageCustomerManageIdIndexRoute,
  authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute:
    authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute,
}

const authLayoutRouteWithChildren = authLayoutRoute._addFileChildren(
  authLayoutRouteChildren,
)

interface authRouteChildren {
  authLayoutRoute: typeof authLayoutRouteWithChildren
}

const authRouteChildren: authRouteChildren = {
  authLayoutRoute: authLayoutRouteWithChildren,
}

const authRouteWithChildren = authRoute._addFileChildren(authRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof authLayoutIndexRoute
  '/login': typeof nonAuthLoginRoute
  '/deeplink/sales-management-change': typeof nonAuthDeeplinkSalesManagementChangeRoute
  '/deeplink': typeof nonAuthDeeplinkIndexRoute
  '/approval/$requestId': typeof authLayoutApprovalRequestIdRoute
  '/manage/report-manage-1': typeof authLayoutManageReportManage1Route
  '/manage/report-manage-2': typeof authLayoutManageReportManage2Route
  '/search/detail-search': typeof authLayoutSearchDetailSearchRoute
  '/search/map-search': typeof authLayoutSearchMapSearchRoute
  '/search/simple-search': typeof authLayoutSearchSimpleSearchRoute
  '/tax-accountant/register': typeof authLayoutTaxAccountantRegisterRoute
  '/tax-accountant/registration-status': typeof authLayoutTaxAccountantRegistrationStatusRoute
  '/tax-corporation/$taxCorporationId': typeof authLayoutTaxCorporationTaxCorporationIdRoute
  '/approval': typeof authLayoutApprovalIndexRoute
  '/business': typeof authLayoutBusinessIndexRoute
  '/manage': typeof authLayoutManageIndexRoute
  '/prize': typeof authLayoutPrizeIndexRoute
  '/search': typeof authLayoutSearchIndexRoute
  '/tax-accountant': typeof authLayoutTaxAccountantIndexRoute
  '/manage/customer-manage/register': typeof authLayoutManageCustomerManageRegisterRoute
  '/manage/tax-accountant-consultation/register': typeof authLayoutManageTaxAccountantConsultationRegisterRoute
  '/tax-accountant/$taxAccountantId/modify': typeof authLayoutTaxAccountantTaxAccountantIdModifyRoute
  '/manage/customer-manage': typeof authLayoutManageCustomerManageIndexRoute
  '/manage/tax-accountant-consultation': typeof authLayoutManageTaxAccountantConsultationIndexRoute
  '/tax-accountant/$taxAccountantId': typeof authLayoutTaxAccountantTaxAccountantIdIndexRoute
  '/manage/customer-manage/$customerManageId/modify': typeof authLayoutManageCustomerManageCustomerManageIdModifyRoute
  '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify': typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute
  '/manage/customer-manage/$customerManageId': typeof authLayoutManageCustomerManageCustomerManageIdIndexRoute
  '/manage/tax-accountant-consultation/$taxAccountantConsultationId': typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof nonAuthLoginRoute
  '/deeplink/sales-management-change': typeof nonAuthDeeplinkSalesManagementChangeRoute
  '/': typeof authLayoutIndexRoute
  '/deeplink': typeof nonAuthDeeplinkIndexRoute
  '/approval/$requestId': typeof authLayoutApprovalRequestIdRoute
  '/manage/report-manage-1': typeof authLayoutManageReportManage1Route
  '/manage/report-manage-2': typeof authLayoutManageReportManage2Route
  '/search/detail-search': typeof authLayoutSearchDetailSearchRoute
  '/search/map-search': typeof authLayoutSearchMapSearchRoute
  '/search/simple-search': typeof authLayoutSearchSimpleSearchRoute
  '/tax-accountant/register': typeof authLayoutTaxAccountantRegisterRoute
  '/tax-accountant/registration-status': typeof authLayoutTaxAccountantRegistrationStatusRoute
  '/tax-corporation/$taxCorporationId': typeof authLayoutTaxCorporationTaxCorporationIdRoute
  '/approval': typeof authLayoutApprovalIndexRoute
  '/business': typeof authLayoutBusinessIndexRoute
  '/manage': typeof authLayoutManageIndexRoute
  '/prize': typeof authLayoutPrizeIndexRoute
  '/search': typeof authLayoutSearchIndexRoute
  '/tax-accountant': typeof authLayoutTaxAccountantIndexRoute
  '/manage/customer-manage/register': typeof authLayoutManageCustomerManageRegisterRoute
  '/manage/tax-accountant-consultation/register': typeof authLayoutManageTaxAccountantConsultationRegisterRoute
  '/tax-accountant/$taxAccountantId/modify': typeof authLayoutTaxAccountantTaxAccountantIdModifyRoute
  '/manage/customer-manage': typeof authLayoutManageCustomerManageIndexRoute
  '/manage/tax-accountant-consultation': typeof authLayoutManageTaxAccountantConsultationIndexRoute
  '/tax-accountant/$taxAccountantId': typeof authLayoutTaxAccountantTaxAccountantIdIndexRoute
  '/manage/customer-manage/$customerManageId/modify': typeof authLayoutManageCustomerManageCustomerManageIdModifyRoute
  '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify': typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute
  '/manage/customer-manage/$customerManageId': typeof authLayoutManageCustomerManageCustomerManageIdIndexRoute
  '/manage/tax-accountant-consultation/$taxAccountantConsultationId': typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(auth)': typeof authRouteWithChildren
  '/(auth)/_layout': typeof authLayoutRouteWithChildren
  '/(non-auth)/login': typeof nonAuthLoginRoute
  '/(non-auth)/deeplink/sales-management-change': typeof nonAuthDeeplinkSalesManagementChangeRoute
  '/(auth)/_layout/': typeof authLayoutIndexRoute
  '/(non-auth)/deeplink/': typeof nonAuthDeeplinkIndexRoute
  '/(auth)/_layout/approval/$requestId': typeof authLayoutApprovalRequestIdRoute
  '/(auth)/_layout/manage/report-manage-1': typeof authLayoutManageReportManage1Route
  '/(auth)/_layout/manage/report-manage-2': typeof authLayoutManageReportManage2Route
  '/(auth)/_layout/search/detail-search': typeof authLayoutSearchDetailSearchRoute
  '/(auth)/_layout/search/map-search': typeof authLayoutSearchMapSearchRoute
  '/(auth)/_layout/search/simple-search': typeof authLayoutSearchSimpleSearchRoute
  '/(auth)/_layout/tax-accountant/register': typeof authLayoutTaxAccountantRegisterRoute
  '/(auth)/_layout/tax-accountant/registration-status': typeof authLayoutTaxAccountantRegistrationStatusRoute
  '/(auth)/_layout/tax-corporation/$taxCorporationId': typeof authLayoutTaxCorporationTaxCorporationIdRoute
  '/(auth)/_layout/approval/': typeof authLayoutApprovalIndexRoute
  '/(auth)/_layout/business/': typeof authLayoutBusinessIndexRoute
  '/(auth)/_layout/manage/': typeof authLayoutManageIndexRoute
  '/(auth)/_layout/prize/': typeof authLayoutPrizeIndexRoute
  '/(auth)/_layout/search/': typeof authLayoutSearchIndexRoute
  '/(auth)/_layout/tax-accountant/': typeof authLayoutTaxAccountantIndexRoute
  '/(auth)/_layout/manage/customer-manage/register': typeof authLayoutManageCustomerManageRegisterRoute
  '/(auth)/_layout/manage/tax-accountant-consultation/register': typeof authLayoutManageTaxAccountantConsultationRegisterRoute
  '/(auth)/_layout/tax-accountant/$taxAccountantId/modify': typeof authLayoutTaxAccountantTaxAccountantIdModifyRoute
  '/(auth)/_layout/manage/customer-manage/': typeof authLayoutManageCustomerManageIndexRoute
  '/(auth)/_layout/manage/tax-accountant-consultation/': typeof authLayoutManageTaxAccountantConsultationIndexRoute
  '/(auth)/_layout/tax-accountant/$taxAccountantId/': typeof authLayoutTaxAccountantTaxAccountantIdIndexRoute
  '/(auth)/_layout/manage/customer-manage/$customerManageId/modify': typeof authLayoutManageCustomerManageCustomerManageIdModifyRoute
  '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify': typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdModifyRoute
  '/(auth)/_layout/manage/customer-manage/$customerManageId/': typeof authLayoutManageCustomerManageCustomerManageIdIndexRoute
  '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/': typeof authLayoutManageTaxAccountantConsultationTaxAccountantConsultationIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/deeplink/sales-management-change'
    | '/deeplink'
    | '/approval/$requestId'
    | '/manage/report-manage-1'
    | '/manage/report-manage-2'
    | '/search/detail-search'
    | '/search/map-search'
    | '/search/simple-search'
    | '/tax-accountant/register'
    | '/tax-accountant/registration-status'
    | '/tax-corporation/$taxCorporationId'
    | '/approval'
    | '/business'
    | '/manage'
    | '/prize'
    | '/search'
    | '/tax-accountant'
    | '/manage/customer-manage/register'
    | '/manage/tax-accountant-consultation/register'
    | '/tax-accountant/$taxAccountantId/modify'
    | '/manage/customer-manage'
    | '/manage/tax-accountant-consultation'
    | '/tax-accountant/$taxAccountantId'
    | '/manage/customer-manage/$customerManageId/modify'
    | '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
    | '/manage/customer-manage/$customerManageId'
    | '/manage/tax-accountant-consultation/$taxAccountantConsultationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/deeplink/sales-management-change'
    | '/'
    | '/deeplink'
    | '/approval/$requestId'
    | '/manage/report-manage-1'
    | '/manage/report-manage-2'
    | '/search/detail-search'
    | '/search/map-search'
    | '/search/simple-search'
    | '/tax-accountant/register'
    | '/tax-accountant/registration-status'
    | '/tax-corporation/$taxCorporationId'
    | '/approval'
    | '/business'
    | '/manage'
    | '/prize'
    | '/search'
    | '/tax-accountant'
    | '/manage/customer-manage/register'
    | '/manage/tax-accountant-consultation/register'
    | '/tax-accountant/$taxAccountantId/modify'
    | '/manage/customer-manage'
    | '/manage/tax-accountant-consultation'
    | '/tax-accountant/$taxAccountantId'
    | '/manage/customer-manage/$customerManageId/modify'
    | '/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
    | '/manage/customer-manage/$customerManageId'
    | '/manage/tax-accountant-consultation/$taxAccountantConsultationId'
  id:
    | '__root__'
    | '/(auth)'
    | '/(auth)/_layout'
    | '/(non-auth)/login'
    | '/(non-auth)/deeplink/sales-management-change'
    | '/(auth)/_layout/'
    | '/(non-auth)/deeplink/'
    | '/(auth)/_layout/approval/$requestId'
    | '/(auth)/_layout/manage/report-manage-1'
    | '/(auth)/_layout/manage/report-manage-2'
    | '/(auth)/_layout/search/detail-search'
    | '/(auth)/_layout/search/map-search'
    | '/(auth)/_layout/search/simple-search'
    | '/(auth)/_layout/tax-accountant/register'
    | '/(auth)/_layout/tax-accountant/registration-status'
    | '/(auth)/_layout/tax-corporation/$taxCorporationId'
    | '/(auth)/_layout/approval/'
    | '/(auth)/_layout/business/'
    | '/(auth)/_layout/manage/'
    | '/(auth)/_layout/prize/'
    | '/(auth)/_layout/search/'
    | '/(auth)/_layout/tax-accountant/'
    | '/(auth)/_layout/manage/customer-manage/register'
    | '/(auth)/_layout/manage/tax-accountant-consultation/register'
    | '/(auth)/_layout/tax-accountant/$taxAccountantId/modify'
    | '/(auth)/_layout/manage/customer-manage/'
    | '/(auth)/_layout/manage/tax-accountant-consultation/'
    | '/(auth)/_layout/tax-accountant/$taxAccountantId/'
    | '/(auth)/_layout/manage/customer-manage/$customerManageId/modify'
    | '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify'
    | '/(auth)/_layout/manage/customer-manage/$customerManageId/'
    | '/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  authRoute: typeof authRouteWithChildren
  nonAuthLoginRoute: typeof nonAuthLoginRoute
  nonAuthDeeplinkSalesManagementChangeRoute: typeof nonAuthDeeplinkSalesManagementChangeRoute
  nonAuthDeeplinkIndexRoute: typeof nonAuthDeeplinkIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  authRoute: authRouteWithChildren,
  nonAuthLoginRoute: nonAuthLoginRoute,
  nonAuthDeeplinkSalesManagementChangeRoute:
    nonAuthDeeplinkSalesManagementChangeRoute,
  nonAuthDeeplinkIndexRoute: nonAuthDeeplinkIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(auth)",
        "/(non-auth)/login",
        "/(non-auth)/deeplink/sales-management-change",
        "/(non-auth)/deeplink/"
      ]
    },
    "/(auth)": {
      "filePath": "(auth)",
      "children": [
        "/(auth)/_layout"
      ]
    },
    "/(auth)/_layout": {
      "filePath": "(auth)/_layout.tsx",
      "parent": "/(auth)",
      "children": [
        "/(auth)/_layout/",
        "/(auth)/_layout/approval/$requestId",
        "/(auth)/_layout/manage/report-manage-1",
        "/(auth)/_layout/manage/report-manage-2",
        "/(auth)/_layout/search/detail-search",
        "/(auth)/_layout/search/map-search",
        "/(auth)/_layout/search/simple-search",
        "/(auth)/_layout/tax-accountant/register",
        "/(auth)/_layout/tax-accountant/registration-status",
        "/(auth)/_layout/tax-corporation/$taxCorporationId",
        "/(auth)/_layout/approval/",
        "/(auth)/_layout/business/",
        "/(auth)/_layout/manage/",
        "/(auth)/_layout/prize/",
        "/(auth)/_layout/search/",
        "/(auth)/_layout/tax-accountant/",
        "/(auth)/_layout/manage/customer-manage/register",
        "/(auth)/_layout/manage/tax-accountant-consultation/register",
        "/(auth)/_layout/tax-accountant/$taxAccountantId/modify",
        "/(auth)/_layout/manage/customer-manage/",
        "/(auth)/_layout/manage/tax-accountant-consultation/",
        "/(auth)/_layout/tax-accountant/$taxAccountantId/",
        "/(auth)/_layout/manage/customer-manage/$customerManageId/modify",
        "/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify",
        "/(auth)/_layout/manage/customer-manage/$customerManageId/",
        "/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/"
      ]
    },
    "/(non-auth)/login": {
      "filePath": "(non-auth)/login.tsx"
    },
    "/(non-auth)/deeplink/sales-management-change": {
      "filePath": "(non-auth)/deeplink/sales-management-change.tsx"
    },
    "/(auth)/_layout/": {
      "filePath": "(auth)/_layout/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(non-auth)/deeplink/": {
      "filePath": "(non-auth)/deeplink/index.tsx"
    },
    "/(auth)/_layout/approval/$requestId": {
      "filePath": "(auth)/_layout/approval/$requestId.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/report-manage-1": {
      "filePath": "(auth)/_layout/manage/report-manage-1.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/report-manage-2": {
      "filePath": "(auth)/_layout/manage/report-manage-2.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/search/detail-search": {
      "filePath": "(auth)/_layout/search/detail-search.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/search/map-search": {
      "filePath": "(auth)/_layout/search/map-search.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/search/simple-search": {
      "filePath": "(auth)/_layout/search/simple-search.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/tax-accountant/register": {
      "filePath": "(auth)/_layout/tax-accountant/register.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/tax-accountant/registration-status": {
      "filePath": "(auth)/_layout/tax-accountant/registration-status.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/tax-corporation/$taxCorporationId": {
      "filePath": "(auth)/_layout/tax-corporation/$taxCorporationId.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/approval/": {
      "filePath": "(auth)/_layout/approval/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/business/": {
      "filePath": "(auth)/_layout/business/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/": {
      "filePath": "(auth)/_layout/manage/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/prize/": {
      "filePath": "(auth)/_layout/prize/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/search/": {
      "filePath": "(auth)/_layout/search/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/tax-accountant/": {
      "filePath": "(auth)/_layout/tax-accountant/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/customer-manage/register": {
      "filePath": "(auth)/_layout/manage/customer-manage/register.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/tax-accountant-consultation/register": {
      "filePath": "(auth)/_layout/manage/tax-accountant-consultation/register.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/tax-accountant/$taxAccountantId/modify": {
      "filePath": "(auth)/_layout/tax-accountant/$taxAccountantId/modify.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/customer-manage/": {
      "filePath": "(auth)/_layout/manage/customer-manage/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/tax-accountant-consultation/": {
      "filePath": "(auth)/_layout/manage/tax-accountant-consultation/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/tax-accountant/$taxAccountantId/": {
      "filePath": "(auth)/_layout/tax-accountant/$taxAccountantId/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/customer-manage/$customerManageId/modify": {
      "filePath": "(auth)/_layout/manage/customer-manage/$customerManageId/modify.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify": {
      "filePath": "(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/modify.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/customer-manage/$customerManageId/": {
      "filePath": "(auth)/_layout/manage/customer-manage/$customerManageId/index.tsx",
      "parent": "/(auth)/_layout"
    },
    "/(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/": {
      "filePath": "(auth)/_layout/manage/tax-accountant-consultation/$taxAccountantConsultationId/index.tsx",
      "parent": "/(auth)/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
